export default {
  getHeaders(vm) {
    return [
      {
        key: 'nomeEmpresa',
        label: vm.$t('network-management.fields.company'),
        class: 'text-center',
      },
      {
        key: 'nomeInstalacao',
        label: vm.$t('network-management.fields.installation'),
      },
      {
        key: 'nomeRede',
        label: vm.$t('network-management.fields.name'),
      },
      {
        key: 'ip',
        label: vm.$t('network-management.fields.ip'),
      },
      {
        key: 'porta',
        label: vm.$t('network-management.fields.port'),
      },
      {
        key: 'status',
        label: vm.$t('network-management.fields.status'),
      },
      {
        key: 'protocolo',
        label: vm.$t('network-management.fields.protocol'),
        sortable: false,
      },
      {
        key: 'view-network',
        label: '',
        class: 'max-view-network-width',
      },
      {
        key: 'actions',
        label: '',
        class: 'max-actions-width',
      },
    ];
  },
};
